var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { height: _vm.maxHeight, overflow: "auto" } },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "6px 0 16px 0" } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.hasDataPermission("manage", _vm.param.privileges)
                ? _c(
                    "deBtn",
                    {
                      attrs: { secondary: "", icon: "el-icon-plus" },
                      on: { click: _vm.addCalcField },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("dataset.add_calc_field")) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.hasDataPermission("manage", _vm.param.privileges) &&
              _vm.table.type !== "excel" &&
              _vm.table.type !== "custom" &&
              _vm.table.type !== "union"
                ? _c(
                    "deBtn",
                    {
                      attrs: {
                        secondary: "",
                        loading: _vm.isSyncField,
                        icon: "el-icon-refresh-left",
                      },
                      on: { click: _vm.syncField },
                    },
                    [_vm._v(_vm._s(_vm.$t("dataset.sync_field")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v("\n       \n    "),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
            [
              _c("el-input", {
                staticClass: "main-area-input",
                staticStyle: { width: "240px" },
                attrs: {
                  size: "small",
                  placeholder: _vm.$t("deDataset.search_fields"),
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                model: {
                  value: _vm.searchField,
                  callback: function ($$v) {
                    _vm.searchField = $$v
                  },
                  expression: "searchField",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          staticClass: "style-collapse",
          model: {
            value: _vm.fieldActiveNames,
            callback: function ($$v) {
              _vm.fieldActiveNames = $$v
            },
            expression: "fieldActiveNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            {
              staticClass: "dimension",
              attrs: {
                name: "d",
                title:
                  _vm.$t("chart.dimension") +
                  " (" +
                  _vm.tableFields.dimensionListData.length +
                  ")",
              },
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableFields.dimensionListData,
                    size: "mini",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "checked",
                      label: _vm.$t("dataset.field_check"),
                      width: "60",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.dimensionIndeterminate,
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: { change: _vm.saveDimension },
                              model: {
                                value: _vm.dimensionChecked,
                                callback: function ($$v) {
                                  _vm.dimensionChecked = $$v
                                },
                                expression: "dimensionChecked",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.checked,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "checked", $$v)
                                },
                                expression: "scope.row.checked",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "name",
                      label: _vm.$t("dataset.field_name"),
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                size: "mini",
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  !(
                    (_vm.table.mode === 0 && _vm.table.type === "custom") ||
                    _vm.table.type === "union"
                  )
                    ? _c("el-table-column", {
                        attrs: {
                          property: "originName",
                          label: _vm.$t("dataset.field_origin_name"),
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.extField === 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "field-class",
                                          staticStyle: {
                                            width: "100%",
                                            "white-space": "nowrap",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                          },
                                          attrs: {
                                            title: scope.row.originName,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.originName)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : scope.row.extField === 2
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "field-class",
                                          staticStyle: {
                                            width: "100%",
                                            "white-space": "nowrap",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                          },
                                          attrs: {
                                            title: _vm.$t("dataset.calc_field"),
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                color: "#c0c0c0",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.calc_field")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1179641562
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      property: "deTypeCascader",
                      label: _vm.$t("dataset.field_type"),
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-cascader", {
                              staticClass: "select-type",
                              attrs: {
                                size: "small",
                                "popper-class": "select-date-resolution-format",
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                                options: _vm.getFields(scope.row),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        node.level === 2 &&
                                        data.label === "yyyy-MM-dd"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "format-title",
                                                style: _vm.popPosition,
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("chart.date_format")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          [
                                            data.value === 0
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-text field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_text",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 1
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-time field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_time",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 2 || data.value === 3
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-value field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_value",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 5
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-location field-icon-dimension",
                                                  attrs: {
                                                    "icon-class":
                                                      "field_location",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#8492a6",
                                              "font-size": "12px",
                                            },
                                          },
                                          [_vm._v(_vm._s(data.label))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: scope.row.deTypeCascader,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "deTypeCascader", $$v)
                                },
                                expression: "scope.row.deTypeCascader",
                              },
                            }),
                            _c("span", { staticClass: "select-svg-icon" }, [
                              scope.row.deType === 0 || scope.row.deType === 6
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 0 ||
                                      scope.row.deType === 6
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-text field-icon-dimension",
                                            attrs: {
                                              "icon-class": "field_text",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 1
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 1
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-time field-icon-dimension",
                                            attrs: {
                                              "icon-class": "field_time",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 2 || scope.row.deType === 3
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 2 ||
                                      scope.row.deType === 3
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-value field-icon-dimension",
                                            attrs: {
                                              "icon-class": "field_value",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 5
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 5
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-location field-icon-dimension",
                                            attrs: {
                                              "icon-class": "field_location",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            scope.row.deType === 1 &&
                            scope.row.deExtractType === 0
                              ? _c("el-input", {
                                  staticClass: "input-type",
                                  attrs: {
                                    placeholder: _vm.$t("dataset.date_format"),
                                    size: "small",
                                    disabled: !_vm.hasDataPermission(
                                      "manage",
                                      _vm.param.privileges
                                    ),
                                  },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.saveEdit(scope.row)
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.saveEdit(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.dateFormat,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "dateFormat", $$v)
                                    },
                                    expression: "scope.row.dateFormat",
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deExtractType",
                      label: _vm.$t("dataset.origin_field_type"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.extField === 0
                              ? _c("span", [
                                  scope.row.deExtractType === 0 ||
                                  scope.row.deExtractType === 6
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 0 ||
                                          scope.row.deExtractType === 6
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-text field-icon-dimension",
                                                attrs: {
                                                  "icon-class": "field_text",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.text"))
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 1
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 1
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-time field-icon-dimension",
                                                attrs: {
                                                  "icon-class": "field_time",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.time"))
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 2 ||
                                  scope.row.deExtractType === 3 ||
                                  scope.row.deExtractType === 4
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 2 ||
                                          scope.row.deExtractType === 3 ||
                                          scope.row.deExtractType === 4
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-value field-icon-dimension",
                                                attrs: {
                                                  "icon-class": "field_value",
                                                },
                                              })
                                            : _vm._e(),
                                          scope.row.deExtractType === 2 ||
                                          scope.row.deExtractType === 4
                                            ? _c(
                                                "span",
                                                { staticClass: "field-class" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("dataset.value")
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.deExtractType === 3
                                            ? _c(
                                                "span",
                                                { staticClass: "field-class" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("dataset.value") +
                                                        "(" +
                                                        _vm.$t(
                                                          "dataset.float"
                                                        ) +
                                                        ")"
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 5
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 5
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-location field-icon-dimension",
                                                attrs: {
                                                  "icon-class":
                                                    "field_location",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.location")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : scope.row.extField === 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "field-class",
                                    staticStyle: {
                                      width: "100%",
                                      "white-space": "nowrap",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                    },
                                    attrs: {
                                      title: _vm.$t("dataset.calc_field"),
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#c0c0c0",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("dataset.calc_field"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "min-width": "182",
                      label: _vm.$t("dataset.operator"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "de-text-btn",
                                  staticStyle: { "margin-left": "-4px" },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.hasDataPermission(
                                      "manage",
                                      _vm.param.privileges
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dqTrans(scope.row, "d")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("deDataset.convert_to_indicator")
                                    ) + "\n            "
                                  ),
                                ]
                              ),
                              scope.row.extField !== 0
                                ? [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "de-text-btn",
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: {
                                          disabled: !_vm.hasDataPermission(
                                            "manage",
                                            _vm.param.privileges
                                          ),
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editField(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("dataset.edit")) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: {
                                          size: "medium",
                                          trigger: "click",
                                        },
                                        on: {
                                          command: function (type) {
                                            return _vm.handleCommand(
                                              type,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass:
                                            "el-icon-more de-text-btn",
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { type: "text" },
                                        }),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticClass: "de-card-dropdown",
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _vm._t("default", [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      !_vm.hasDataPermission(
                                                        "manage",
                                                        _vm.param.privileges
                                                      ),
                                                    command: "copy",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy",
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("dataset.copy")
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      !_vm.hasDataPermission(
                                                        "manage",
                                                        _vm.param.privileges
                                                      ),
                                                    command: "delete",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("chart.delete")
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "de-text-btn",
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        disabled: !_vm.hasDataPermission(
                                          "manage",
                                          _vm.param.privileges
                                        ),
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyField(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dataset.copy")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            {
              staticClass: "quota",
              attrs: {
                name: "q",
                title:
                  _vm.$t("chart.quota") +
                  " (" +
                  _vm.tableFields.quotaListData.length +
                  ")",
              },
            },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.tableFields.quotaListData, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "checked",
                      label: _vm.$t("dataset.field_check"),
                      width: "60",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                indeterminate: _vm.quotaIndeterminate,
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: { change: _vm.saveQuota },
                              model: {
                                value: _vm.quotaChecked,
                                callback: function ($$v) {
                                  _vm.quotaChecked = $$v
                                },
                                expression: "quotaChecked",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.checked,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "checked", $$v)
                                },
                                expression: "scope.row.checked",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "name",
                      label: _vm.$t("dataset.field_name"),
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                size: "mini",
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  !(
                    (_vm.table.mode === 0 && _vm.table.type === "custom") ||
                    _vm.table.type === "union"
                  )
                    ? _c("el-table-column", {
                        attrs: {
                          property: "originName",
                          label: _vm.$t("dataset.field_origin_name"),
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.extField === 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "field-class",
                                          staticStyle: {
                                            width: "100%",
                                            "white-space": "nowrap",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                          },
                                          attrs: {
                                            title: scope.row.originName,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.originName)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : scope.row.extField === 2
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "field-class",
                                          staticStyle: {
                                            width: "100%",
                                            "white-space": "nowrap",
                                            overflow: "hidden",
                                            "text-overflow": "ellipsis",
                                          },
                                          attrs: {
                                            title: _vm.$t("dataset.calc_field"),
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                color: "#c0c0c0",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.calc_field")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1179641562
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      property: "deTypeCascader",
                      label: _vm.$t("dataset.field_type"),
                      "min-width": "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-cascader", {
                              staticClass: "select-type",
                              attrs: {
                                size: "small",
                                "popper-class": "select-date-resolution-format",
                                disabled: !_vm.hasDataPermission(
                                  "manage",
                                  _vm.param.privileges
                                ),
                                options: _vm.getFields(scope.row),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.saveEdit(scope.row)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var node = ref.node
                                      var data = ref.data
                                      return [
                                        node.level === 2 &&
                                        data.label === "yyyy-MM-dd"
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "format-title",
                                                style: _vm.popPosition,
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("chart.date_format")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          [
                                            data.value === 0
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-text field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_text",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 1
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-time field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_time",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 2 || data.value === 3
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-value field-icon-dimension",
                                                  attrs: {
                                                    "icon-class": "field_value",
                                                  },
                                                })
                                              : _vm._e(),
                                            data.value === 5
                                              ? _c("svg-icon", {
                                                  staticClass:
                                                    "field-icon-location field-icon-dimension",
                                                  attrs: {
                                                    "icon-class":
                                                      "field_location",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#8492a6",
                                              "font-size": "12px",
                                            },
                                          },
                                          [_vm._v(_vm._s(data.label))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: scope.row.deTypeCascader,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "deTypeCascader", $$v)
                                },
                                expression: "scope.row.deTypeCascader",
                              },
                            }),
                            _c("span", { staticClass: "select-svg-icon" }, [
                              scope.row.deType === 0
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 0
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-text field-icon-quota",
                                            attrs: {
                                              "icon-class": "field_text",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 1
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 1
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-time field-icon-quota",
                                            attrs: {
                                              "icon-class": "field_time",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 2 || scope.row.deType === 3
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 2 ||
                                      scope.row.deType === 3
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-value field-icon-quota",
                                            attrs: {
                                              "icon-class": "field_value",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.deType === 5
                                ? _c(
                                    "span",
                                    [
                                      scope.row.deType === 5
                                        ? _c("svg-icon", {
                                            staticClass:
                                              "field-icon-location field-icon-quota",
                                            attrs: {
                                              "icon-class": "field_location",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            scope.row.deType === 1 &&
                            scope.row.deExtractType === 0
                              ? _c("el-input", {
                                  staticClass: "input-type",
                                  attrs: {
                                    placeholder: _vm.$t("dataset.date_format"),
                                    size: "small",
                                    disabled: !_vm.hasDataPermission(
                                      "manage",
                                      _vm.param.privileges
                                    ),
                                  },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.saveEdit(scope.row)
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.saveEdit(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.dateFormat,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "dateFormat", $$v)
                                    },
                                    expression: "scope.row.dateFormat",
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "deExtractType",
                      label: _vm.$t("dataset.origin_field_type"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.extField === 0
                              ? _c("span", [
                                  scope.row.deExtractType === 0
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 0
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-text field-icon-quota",
                                                attrs: {
                                                  "icon-class": "field_text",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.text"))
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 1
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 1
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-time field-icon-quota",
                                                attrs: {
                                                  "icon-class": "field_time",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("dataset.time"))
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 2 ||
                                  scope.row.deExtractType === 3 ||
                                  scope.row.deExtractType === 4
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 2 ||
                                          scope.row.deExtractType === 3 ||
                                          scope.row.deExtractType === 4
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-value field-icon-quota",
                                                attrs: {
                                                  "icon-class": "field_value",
                                                },
                                              })
                                            : _vm._e(),
                                          scope.row.deExtractType === 2 ||
                                          scope.row.deExtractType === 4
                                            ? _c(
                                                "span",
                                                { staticClass: "field-class" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("dataset.value")
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.deExtractType === 3
                                            ? _c(
                                                "span",
                                                { staticClass: "field-class" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("dataset.value") +
                                                        "(" +
                                                        _vm.$t(
                                                          "dataset.float"
                                                        ) +
                                                        ")"
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.deExtractType === 5
                                    ? _c(
                                        "span",
                                        [
                                          scope.row.deExtractType === 5
                                            ? _c("svg-icon", {
                                                staticClass:
                                                  "field-icon-location field-icon-quota",
                                                attrs: {
                                                  "icon-class":
                                                    "field_location",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "field-class" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dataset.location")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : scope.row.extField === 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "field-class",
                                    staticStyle: {
                                      width: "100%",
                                      "white-space": "nowrap",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                    },
                                    attrs: {
                                      title: _vm.$t("dataset.calc_field"),
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#c0c0c0",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("dataset.calc_field"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "min-width": "182",
                      property: "",
                      label: _vm.$t("dataset.operator"),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "de-text-btn",
                                  staticStyle: { "margin-left": "-4px" },
                                  attrs: {
                                    type: "text",
                                    disabled: !_vm.hasDataPermission(
                                      "manage",
                                      _vm.param.privileges
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dqTrans(scope.row, "q")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("deDataset.convert_to_dimension")
                                    ) + "\n            "
                                  ),
                                ]
                              ),
                              scope.row.extField !== 0
                                ? [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "de-text-btn",
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: {
                                          disabled: !_vm.hasDataPermission(
                                            "manage",
                                            _vm.param.privileges
                                          ),
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editField(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("dataset.edit")) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        attrs: {
                                          size: "medium",
                                          trigger: "click",
                                        },
                                        on: {
                                          command: function (type) {
                                            return _vm.handleCommand(
                                              type,
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass:
                                            "el-icon-more de-text-btn",
                                          staticStyle: { "margin-left": "8px" },
                                          attrs: { type: "text" },
                                        }),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            staticClass: "de-card-dropdown",
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _vm._t("default", [
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      !_vm.hasDataPermission(
                                                        "manage",
                                                        _vm.param.privileges
                                                      ),
                                                    command: "copy",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy",
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("dataset.copy")
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-dropdown-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      !_vm.hasDataPermission(
                                                        "manage",
                                                        _vm.param.privileges
                                                      ),
                                                    command: "delete",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("chart.delete")
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "de-text-btn",
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        disabled: !_vm.hasDataPermission(
                                          "manage",
                                          _vm.param.privileges
                                        ),
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyField(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dataset.copy")) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "de-dialog-form de-center-dialog",
          attrs: {
            visible: _vm.editCalcField,
            width: "980px",
            title: _vm.currEditField.id
              ? _vm.$t("dataset.edit_calc_field")
              : _vm.$t("dataset.add_calc_field"),
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editCalcField = $event
            },
          },
        },
        [
          _c("calc-field-edit", {
            attrs: {
              param: _vm.param,
              "table-fields": _vm.tableFields,
              field: _vm.currEditField,
            },
            on: { onEditClose: _vm.closeCalcField },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }